export default __webpack_public_path__ + "static/media/0079.31286e02.png";